import React, { useState, useContext } from "react"
import { Mutation } from "react-apollo"
import Button from "../../../../../components/Button"
import { getViewerFolders } from "../../../queries"
import gql from "graphql-tag"
import TextField from "../../../../../components/TextField"
import { ModalMessage } from "../../../../../components/Modal"
import AppContext from "../../../../../shared/AppContext"

const UPDATE_FAVORITE_FOLDER = gql`
  mutation UPDATE_FAVORITE_FOLDER($folderId: String!, $name: String!) {
    updateFavoritesFolder(folderId: $folderId, name: $name) {
      response {
        payload
        message
      }
    }
  }
`

const MESSAGE_TYPE = {
  SUCCESS: "success",
  SAVE_ERROR: "saveError",
  NOT_AUTHORIZED: "notAuthorized",
  REQUIRED: "isRequired",
  ALREADY_EXISTS: "alreadyExists",
}

export default function FolderRename(props) {
  const [folderName, setFolderName] = useState("")
  const [message, setMessage] = useState({
    type: "",
    text: "",
  })
  const { trackingLocation } = props
  const { trackEvent } = useContext(AppContext)

  const handleRename = (mutation) => {
    if (!folderName.trim()) {
      return setMessage({
        type: MESSAGE_TYPE.REQUIRED,
        text: "Name is required.",
      })
    }

    mutation({
      variables: {
        name: folderName.trim(),
        folderId: props.folderId,
      },
      refetchQueries: [{ query: getViewerFolders }],
    })
      .then(({ data }) => {
        const { updateFavoritesFolder } = data
        setMessage({
          type: updateFavoritesFolder.response.payload,
          text: updateFavoritesFolder.response.message,
        })

        if (
          updateFavoritesFolder.response &&
          updateFavoritesFolder.response.payload === MESSAGE_TYPE.SUCCESS
        ) {
          trackEvent("Renamed Folder", {
            location: trackingLocation,
            newName: folderName,
          })
        }
      })
      .catch((err) => {
        setMessage({
          type: MESSAGE_TYPE.SAVE_ERROR,
          text: "Oh no! Something went wrong.",
        })
        console.log("folder rename error", err)
      })
  }

  const hasErrors =
    message.type.toLowerCase() === MESSAGE_TYPE.SAVE_ERROR.toLowerCase() ||
    message.type.toLowerCase() === MESSAGE_TYPE.ALREADY_EXISTS.toLowerCase() ||
    message.type.toLowerCase() === MESSAGE_TYPE.NOT_AUTHORIZED.toLowerCase()

  if (message.type.toLowerCase() == MESSAGE_TYPE.SUCCESS.toLowerCase()) {
    return (
      <ModalMessage
        messageType={MESSAGE_TYPE.SUCCESS}
        text={message.text}
        closeModal={props.closeModal}
      />
    )
  }

  return (
    <Mutation mutation={UPDATE_FAVORITE_FOLDER}>
      {(mutation) => {
        return (
          <div>
            <TextField
              placeholder="Favorite Name"
              label="Name"
              name="name"
              required={true}
              errors={
                message.type.toLowerCase() ==
                MESSAGE_TYPE.REQUIRED.toLowerCase()
              }
              errorOptions={{
                outline: true,
                showMessage: true,
                message: message.text,
                showMessage:
                  message.type.toLowerCase() ==
                  MESSAGE_TYPE.REQUIRED.toLowerCase(),
              }}
              fullWidth={true}
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
            />
            {hasErrors && (
              <ModalMessage
                messageType={MESSAGE_TYPE.SAVE_ERROR}
                text={message.text}
                style={{ textAlign: "right" }}
              />
            )}
            <div className="folder-edit-button-wrap">
              <Button
                action={props.closeModal}
                text="Cancel"
                classes={["btn-cancel"]}
              />
              <Button
                action={() => handleRename(mutation)}
                text="Save"
                classes={["btn-primary"]}
              />
            </div>
          </div>
        )
      }}
    </Mutation>
  )
}
